module.exports = __webpack_public_path__ + "img/1440.a6833194.jpg";